import { render, staticRenderFns } from "./headDetail.vue?vue&type=template&id=d7c39b64&scoped=true"
import script from "./headDetail.vue?vue&type=script&lang=js"
export * from "./headDetail.vue?vue&type=script&lang=js"
import style0 from "./headDetail.vue?vue&type=style&index=0&id=d7c39b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c39b64",
  null
  
)

export default component.exports